// extracted by mini-css-extract-plugin
export default {"mixin":"ScoreItem_mixin__audBp","container":"ScoreItem_container__gQVd9","icon":"ScoreItem_icon__EUanG","title":"ScoreItem_title__RPjeu","value":"ScoreItem_value__yubjF"};